<template>
  <div class="profile-view-page">
    <Profile :id="$route.params.id" @menuEvent="menus.profile = $event" />
  </div>
</template>

<script>
import pageMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-page.mixin.js";

export default {
  mixins: [pageMenuEventBubbler],
  head: {
    title: "Profile",
    titleTemplate: "%s | iU Community",
  },
  data() {
    return {
      menus: {
        profile: false,
      },
    };
  },
};
</script>

<style scoped lang="scss">
.profile-view-page {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.update-profile-btn {
  position: absolute;
  right: 20px;
  top: 20px;
}
</style>
